import React, { useState } from 'react';
import { MenuIcon, X, ChevronDownIcon, ShieldCheck, Activity, Smile, Heart, User, Phone, Package, Gift, RefreshCw } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBenefitOpen, setIsBenefitOpen] = useState(false);
  const [isMobileBenefitOpen, setIsMobileBenefitOpen] = useState(false);

  // Brand color reference: bg-[#496f58]

  return <nav className="bg-[#496f58] fixed top-0 w-full z-50 shadow-sm font-sans border-b border-white/10" data-id="element-195">
      <div className="w-full px-6 lg:px-12 py-4" data-id="element-196">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-197">
          
          {/* Left Navigation - Main Links */}
          <div className="hidden lg:flex items-center gap-8 flex-1" data-id="element-198">
            <NavLink href="https://supplement.faithandfig.com" label="Home" data-id="element-199" />

            {/* Shop by Benefit with hover dropdown */}
            <div className="relative group h-full flex items-center" onMouseEnter={() => setIsBenefitOpen(true)} onMouseLeave={() => setIsBenefitOpen(false)} data-id="element-200">
              <button className={`flex items-center gap-1.5 transition-colors text-xs xl:text-sm font-bold tracking-widest uppercase py-2
                  ${isBenefitOpen ? 'text-white/80' : 'text-white'}`} data-id="element-201">
                Shop By Benefit
                <ChevronDownIcon size={14} className={`transition-transform duration-200 ${isBenefitOpen ? 'rotate-180' : ''}`} data-id="element-202" />
              </button>

              {/* Dropdown Container */}
              <div className={`absolute left-0 top-full w-72 pt-4 transform transition-all duration-200 ease-in-out origin-top-left
                  ${isBenefitOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-2 invisible'}`} data-id="element-203">
                <div className="bg-white rounded-xl shadow-xl ring-1 ring-black/5 overflow-hidden" data-id="element-204">
                  <div className="p-2 space-y-1" data-id="element-205">
                    <DropdownItem href="https://oliveleaf.faithandfig.com" title="Immune Defense" desc="Olive Leaf Extract" icon={ShieldCheck} data-id="element-206" />
                    <DropdownItem href="https://frankincense.faithandfig.com" title="Joint Comfort" desc="Frankincense & Boswellia" icon={Activity} data-id="element-207" />
                    <DropdownItem href="https://trysaffron.faithandfig.com" title="Mood & Focus" desc="Premium Saffron" icon={Smile} data-id="element-208" />
                    <DropdownItem href="https://pomegranates.faithandfig.com" title="Heart & Vitality" desc="Pomegranate Extract" icon={Heart} data-id="element-209" />
                  </div>
                </div>
              </div>
            </div>

            <NavLink href="https://learnmore.faithandfig.com" label="About Us" data-id="element-210" />
            <NavLink href="https://faithandfig.com/pages/contact" label="Contact" data-id="element-211" />
          </div>

          {/* Center Logo */}
          <div className="flex items-center justify-start lg:justify-center flex-shrink-0 mx-4" data-id="element-212">
            <a href="https://supplement.faithandfig.com" className="flex items-center hover:opacity-90 transition-opacity" data-id="element-213">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/1000007566.jpg?v=1763689502" alt="F&F Logo" className="h-8 md:h-10 w-auto" data-id="element-214" />
            </a>
          </div>

          {/* Right Navigation - Utilities & Actions */}
          <div className="hidden lg:flex items-center justify-end gap-6 flex-1" data-id="element-215">
            <div className="flex items-center gap-6 border-r border-white/20 pr-6 mr-2" data-id="element-216">
              <a href="https://faithandfig.com/apps/my-subscriptions" className="group flex items-center gap-2 text-white/90 hover:text-white transition-colors" title="Manage Subscription" data-id="element-217">
                <RefreshCw size={16} className="opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-218" />
                <span className="text-xs font-medium tracking-wide" data-id="element-219">Subscriptions</span>
              </a>
              <a href="https://faithandfig.com/apps/track123" className="group flex items-center gap-2 text-white/90 hover:text-white transition-colors" title="Track Your Order" data-id="element-220">
                <Package size={16} className="opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-221" />
                <span className="text-xs font-medium tracking-wide" data-id="element-222">Track</span>
              </a>
            </div>
            
            <a href="https://faithandfig.com" className="flex items-center gap-2 px-5 py-2.5 bg-white/10 hover:bg-white text-white hover:text-[#496f58] rounded-full transition-all duration-300 backdrop-blur-sm border border-white/20 hover:border-white group shadow-sm hover:shadow-md" data-id="element-223">
              <Gift size={16} className="group-hover:scale-110 transition-transform duration-300" data-id="element-224" />
              <span className="text-xs font-bold tracking-wider uppercase" data-id="element-225">Gift Store</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex justify-end flex-1" data-id="element-226">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white hover:text-white/80 transition-colors p-1" data-id="element-227">
              {isMenuOpen ? <X size={28} data-id="element-228" /> : <MenuIcon size={28} data-id="element-229" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && <div className="lg:hidden w-full bg-[#496f58] border-t border-white/10 h-[calc(100vh-70px)] overflow-y-auto" data-id="element-230">
          <div className="px-6 py-6 flex flex-col h-full" data-id="element-231">
            
            {/* Section 1: Main Navigation */}
            <div className="space-y-4 mb-8" data-id="element-232">
              <p className="text-xs font-bold text-white/40 tracking-widest uppercase" data-id="element-233">Menu</p>
              <a href="https://supplement.faithandfig.com" className="block text-white text-xl font-medium" data-id="element-234">
                HOME
              </a>

              {/* Mobile Shop by Benefit */}
              <div className="space-y-3" data-id="element-235">
                <button onClick={() => setIsMobileBenefitOpen(!isMobileBenefitOpen)} className="flex w-full items-center justify-between text-white text-xl font-medium" data-id="element-236">
                  <span data-id="element-237">SHOP BY BENEFIT</span>
                  <ChevronDownIcon size={20} className={`transition-transform duration-300 ${isMobileBenefitOpen ? 'rotate-180' : ''}`} data-id="element-238" />
                </button>

                <div className={`overflow-hidden transition-all duration-300 ${isMobileBenefitOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-239">
                  <div className="ml-2 pl-4 border-l-2 border-white/20 space-y-3 py-2" data-id="element-240">
                    <MobileLink href="https://oliveleaf.faithandfig.com" label="Immune Defense" data-id="element-241" />
                    <MobileLink href="https://frankincense.faithandfig.com" label="Joint Comfort" data-id="element-242" />
                    <MobileLink href="https://trysaffron.faithandfig.com" label="Mood & Focus" data-id="element-243" />
                    <MobileLink href="https://pomegranates.faithandfig.com" label="Heart & Vitality" data-id="element-244" />
                  </div>
                </div>
              </div>
              
              <a href="https://learnmore.faithandfig.com" className="block text-white text-xl font-medium" data-id="element-245">
                ABOUT US
              </a>
            </div>

            {/* Section 2: Customer Care */}
            <div className="space-y-4 mb-8 border-t border-white/10 pt-6" data-id="element-246">
              <p className="text-xs font-bold text-white/40 tracking-widest uppercase" data-id="element-247">Customer Care</p>
              
              <a href="https://faithandfig.com/pages/contact" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors" data-id="element-248">
                <Phone size={18} data-id="element-249" />
                <span className="font-medium" data-id="element-250">Contact Us</span>
              </a>

              <a href="https://faithandfig.com/apps/my-subscriptions" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors" data-id="element-251">
                <User size={18} data-id="element-252" />
                <span className="font-medium" data-id="element-253">Manage Subscription</span>
              </a>

              <a href="https://faithandfig.com/apps/track123" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors" data-id="element-254">
                <Package size={18} data-id="element-255" />
                <span className="font-medium" data-id="element-256">Track Your Order</span>
              </a>
            </div>

            {/* Section 3: Highlight Actions */}
            <div className="mt-auto pb-8" data-id="element-257">
              <a href="https://faithandfig.com" className="flex items-center justify-center gap-2 w-full px-6 py-4 bg-white text-[#496f58] rounded-xl font-bold shadow-lg hover:bg-gray-100 transition-colors" data-id="element-258">
                <Gift size={20} data-id="element-259" />
                VISIT GIFT STORE
              </a>
              <p className="text-center text-white/30 text-xs mt-6" data-id="element-260">
                © 2025 Faith & Fig. All rights reserved.
              </p>
            </div>

          </div>
        </div>}
    </nav>;
}

// Helper Components

function NavLink({
  href,
  label
}) {
  return <a href={href} className="relative group text-white hover:text-white/90 transition-colors text-xs xl:text-sm font-bold tracking-widest uppercase py-2" data-id="element-261">
      {label}
      <span className="absolute -bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full opacity-0 group-hover:opacity-100" data-id="element-262"></span>
    </a>;
}
function DropdownItem({
  href,
  title,
  desc,
  icon: Icon
}) {
  return <a href={href} className="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-[#F5F3EE] transition-colors group" data-id="element-263">
      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#496f58]/10 text-[#496f58] group-hover:bg-[#496f58] group-hover:text-white transition-colors" data-id="element-264">
        <Icon size={18} strokeWidth={1.5} data-id="element-265" />
      </div>
      <div data-id="element-266">
        <p className="text-sm font-semibold text-[#1A2332] group-hover:text-[#496f58] transition-colors" data-id="element-267">
          {title}
        </p>
        <p className="text-xs text-gray-500 font-medium" data-id="element-268">
          {desc}
        </p>
      </div>
    </a>;
}
function MobileLink({
  href,
  label
}) {
  return <a href={href} className="block text-white/80 hover:text-white transition-colors text-base font-medium" data-id="element-269">
      {label}
    </a>;
}